export const SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS = {
    limitedTimeOffer: "seasonalCampaign.modal.limitedTimeOffer",
    flashSale: "seasonalCampaign.modal.flashSale",
    subTextToAnnual: "seasonalCampaign.modal.subTextToAnnual",
    subText: "seasonalCampaign.modal.subText",
    promoCode: "seasonalCampaign.modal.promoCode",
    upgradeNow: "seasonalCampaign.modal.upgradeNow",
} as const;
